import React from 'react';

import { Row, Column } from '../Layout/Grid';

import refreshImg from 'img/refresh.svg';
import Text from 'components/Text';
import { Button } from 'components/Button';

const RefreshButton: React.FC<{ onReload?: any; }> = (props) => {
  const { onReload } = props;

  return (
    <>
      <Row
        className="absolute bottom-0 left-0 right-0 align-center justify-center"
        style={{ filter: 'blur(5px)', background: '#fff9', zIndex: 9, top: 50 }}
      />
      <Column
        className="absolute bottom-0 left-0 right-0 align-center justify-center"
        style={{ background: 'none', zIndex: 10, top: 50 }}
      >
        <Button
          onClick={onReload ? () => props.onReload() : () => { }}
          className="flex-column"
        >
          <>
            <img
              className="animated rotateIn"
              src={refreshImg}
              alt=""
              style={{ height: 45, width: 45 }}
            />
            <Text className="mt-3 font-bold">
              Ocorreu um erro, tente novamente.
            </Text>
          </>
        </Button>
      </Column>
    </>
  );
};

export default RefreshButton;
